import {
  FilterTemplate,
  IFilterTemplateRepository,
} from "../types/FilterTemplateTypes";

const STORAGE_KEY_PREFIX = "filterTemplates";

const getStorageKey = (username: string): string =>
  `${STORAGE_KEY_PREFIX}_${username.trim()}`;

export class LocalStorageFilterTemplateRepository
  implements IFilterTemplateRepository
{
  constructor(private readonly username: string) {}

  async getAll(): Promise<FilterTemplate[]> {
    const raw = localStorage.getItem(getStorageKey(this.username));
    if (!raw) {
      return [];
    }

    try {
      const parsed = JSON.parse(raw) as FilterTemplate[];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  async save(template: FilterTemplate): Promise<void> {
    const templates = await this.getAll();
    templates.push(template);
    this.writeAll(templates);
  }

  async update(template: FilterTemplate): Promise<void> {
    const templates = await this.getAll();
    const index = templates.findIndex((item) => item.id === template.id);

    if (index === -1) {
      throw new Error("Filter template not found.");
    }

    templates[index] = template;
    this.writeAll(templates);
  }

  async deleteById(id: string): Promise<void> {
    const templates = await this.getAll();
    this.writeAll(templates.filter((item) => item.id !== id));
  }

  private writeAll(templates: FilterTemplate[]): void {
    if (!this.username.trim()) {
      throw new Error("Cannot persist filter templates without a user session.");
    }

    localStorage.setItem(
      getStorageKey(this.username),
      JSON.stringify(templates),
    );
  }
}
